import angular from 'angular';

export class UtilService {
    constructor($window) {
        'ngInject';
        this.$window = $window;
    }

    countUppercase(str=''){
        return str.split('').reduce((accumulator, currentValue) => {
            return /[A-Z]/.test(currentValue)? accumulator + 1 : accumulator;
        }, 0);
    }

    countLowercase(str=''){
        return str.split('').reduce((accumulator, currentValue) => {
            return /[a-z]/.test(currentValue)? accumulator + 1 : accumulator;
        }, 0);
    }

    countNumeric(str=''){
        return str.split('').reduce((accumulator, currentValue) => {
            return /[0-9]/.test(currentValue)? accumulator + 1 : accumulator;
        }, 0);
    }

    countSpecialChar(str=''){
        return str.split('').reduce((accumulator, currentValue) => {
            return /[!@#\$%\^&\*\(\)\\_\+\-=\[\]\{\};':"\|,\.<>\/\?]/.test(currentValue)? accumulator + 1 : accumulator;
        }, 0);
    }

    redirectBackToPrev($transition$, otherwiseStateName){
        let $state = $transition$.router.stateService;

        let redirectTo = $state.target(otherwiseStateName);
        if ($transition$.redirectedFrom() != null) {
            redirectTo = $transition$.redirectedFrom().targetState();
        }
        else if ($transition$.from().name !== '') {
            redirectTo = $state.target($transition$.from(), $transition$.params('from'));
        }

        let state = redirectTo.state();
        let params = redirectTo.params();
        let opts = Object.assign({}, redirectTo.options(), {reload: true});
        $state.go(state, params, opts);
    }

    getMobileType() {
        const urlParams = new URLSearchParams(window.location.search);
        const apptype = urlParams.get('apptype');
        if (apptype) {
            return apptype;
        }
        
        let userAgent = this.$window.navigator.userAgent;
        if (/android/i.test(userAgent) || /Chrome\/([0-9]+[\.]?)+\sMobile/.test(userAgent)) {
            return 'android';
        }
        if (/iPad|iPhone|iPod/.test(userAgent) || userAgent.indexOf(' Mobile/') > 0 && userAgent.indexOf(' Safari/') === -1) {
            return 'iOS';
        }
        return '';
    }

}


// WEBPACK FOOTER //
// ./src/app/services/util.service.js